import { PaymentMethod, PaymentMethodManagerView } from "@types-runway/billing";
import { Address, AddressUpdate, User } from "@types-runway/user";

export const LOGIN = "LOGIN";
export interface Login {
  type: typeof LOGIN;
  email: string;
  password: string;
  startQuestionnaire?: boolean;
}

export const LOGOUT = "LOGOUT";
export enum LogoutReasons {
  SESSION_EXPIRED = "sessionExpired",
}
export interface Logout {
  type: typeof LOGOUT;
  userId: string;
  reason?: LogoutReasons;
}

export const SIGNUP = "SIGNUP";
export interface Signup {
  type: typeof SIGNUP;
  user: User;
}

export const USER_UPDATE = "USER_UPDATE";
export interface UserUpdate {
  type: typeof USER_UPDATE;
  userUpdate: UserUpdate;
}

export const UPDATE_SHIPPING_ADDRESS = "UPDATE_SHIPPING_ADDRESS";
export interface UpdateShippingAddress {
  type: typeof UPDATE_SHIPPING_ADDRESS;
  address: Address;
}

export const RESTORE_PASSWORD = "RESTORE_PASSWORD";
export interface RestorePassword {
  type: typeof RESTORE_PASSWORD;
  email: string;
}

export const COLLECT_MARKETING_EMAIL = "COLLECT_MARKETING_EMAIL";
export interface CollectMarketingEmail {
  type: typeof COLLECT_MARKETING_EMAIL;
  email: string;
  subscribeToNewsLetter: boolean;
  discountBody: {
    promoCode: string;
    partner: string;
  };
}

export const GET_PAYMENT_METHODS = "GET_PAYMENT_METHODS";
export interface GetPaymentMethods {
  type: typeof GET_PAYMENT_METHODS;
}

export const ADD_PAYMENT_METHOD = "ADD_PAYMENT_METHOD";
export interface AddPaymentMethod {
  type: typeof ADD_PAYMENT_METHOD;
  paymentMethodId: string;
  view: PaymentMethodManagerView;
}

// Lets payCase wait on this specific outcome instead of any userMutationSuccess/userError.
export const ADD_PAYMENT_METHOD_SUCCEEDED = "ADD_PAYMENT_METHOD_SUCCEEDED";
export interface AddPaymentMethodSucceeded {
  type: typeof ADD_PAYMENT_METHOD_SUCCEEDED;
  paymentMethodId: string;
}

export const ADD_PAYMENT_METHOD_FAILED = "ADD_PAYMENT_METHOD_FAILED";
export interface AddPaymentMethodFailed {
  type: typeof ADD_PAYMENT_METHOD_FAILED;
  paymentMethodId: string;
  message?: string;
}

export const SET_DEFAULT_PAYMENT_METHOD = "SET_DEFAULT_PAYMENT_METHOD";
export interface SetDefaultPaymentMethod {
  type: typeof SET_DEFAULT_PAYMENT_METHOD;
  methodId: string;
  view: PaymentMethodManagerView;
}

export const DELETE_PAYMENT_METHODS = "DELETE_PAYMENT_METHODS";
export interface DeletePaymentMethods {
  type: typeof DELETE_PAYMENT_METHODS;
  methodIds: string[];
}

export const UPDATE_PAYMENT_METHOD = "UPDATE_PAYMENT_METHOD";
export interface UpdatePaymentMethod {
  type: typeof UPDATE_PAYMENT_METHOD;
  paymentMethodUpdate: PaymentMethod;
}

export const SEND_TRAVEL_GROUP_EMAIL = "SEND_TRAVEL_GROUP_EMAIL";
export interface SendTravelGroupEmail {
  type: typeof SEND_TRAVEL_GROUP_EMAIL;
  emails: string[];
}

export const GET_AFFILIATE_PROFILE = "GET_AFFILIATE_PROFILE";
export interface GetAffiliateLink {
  type: typeof GET_AFFILIATE_PROFILE;
}

export const GET_PROMO_CODES = "GET_PROMO_CODES";
export interface GetPromoCodes {
  type: typeof GET_PROMO_CODES;
}

export const GET_ADDRESSES = "GET_ADDRESSES";
export interface GetAddresses {
  type: typeof GET_ADDRESSES;
  userId: string;
}

export const CREATE_ADDRESS = "CREATE_ADDRESS";
export interface CreateAddress {
  type: typeof CREATE_ADDRESS;
  address: Address;
  userId: string;
}

export const UPDATE_ADDRESS = "UPDATE_ADDRESS";
export interface UpdateAddress {
  type: typeof UPDATE_ADDRESS;
  payload: AddressUpdate;
  addressId: string;
  userId: string;
}

export const DELETE_ADDRESS = "DELETE_ADDRESS";
export interface DeleteAddress {
  type: typeof DELETE_ADDRESS;
  addressId: string;
}
export const CREATE_PATIENT_PROFILE = "CREATE_PATIENT_PROFILE";
export interface CreatePatientProfile {
  type: typeof CREATE_PATIENT_PROFILE;
  userId: string;
}

export const SUBMIT_PHOTO_ID = "SUBMIT_PHOTO_ID";
export interface SubmitPhotoId {
  type: typeof SUBMIT_PHOTO_ID;
  file: File;
}
